import React from 'react';

import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import EditTagRow from '../../../components/edit-tag-row';
import { TagPropType } from '../../../prop-types/tag';
import ModalPortal from '../../modal-portal';
import style from './edit-tag-modal.module.less';
import { useEditTag } from './hooks';
import { messages } from './messages';
import { useTrackWorkflow, WorkflowSteps } from '../../../tracking/use-workflow-tracking';
import { Workflows } from '../../../tracking/tracking-constants';

export const EditTagModal = ({ tag, onClose }) => {
  const { editTag, isSaving, onTagChanged, onSave } = useEditTag({
    initialTag: tag,
    onClose,
  });
  const trackTagManagementWorkflow = useTrackWorkflow(Workflows.TAG_MANAGEMENT_FLOW);

  const onCancel = () => {
    trackTagManagementWorkflow(WorkflowSteps.CANCEL);
    onClose();
  };

  if (!editTag) {
    return null;
  }
  return (
    <ModalPortal onCancel={onCancel} onClose={onClose}>
      <Modal className={style['edit-tag-modal']}>
        <ModalHeader>
          <FormattedMessage {...messages.editTagTitle} />
        </ModalHeader>
        <ModalBody className={style['modal-body']}>
          {isSaving && <LoadingIndicator className={style['loading-indicator']} />}
          {!isSaving && <EditTagRow hideX onChange={onTagChanged} tag={editTag} />}
        </ModalBody>
        {!isSaving && (
          <ModalFooter className={style['modal-footer']}>
            <ModalFooterCancelButton />
            <Button onClick={onSave} theme='primary'>
              <FormattedMessage {...messages.editTagDone} />
            </Button>
          </ModalFooter>
        )}
      </Modal>
    </ModalPortal>
  );
};

EditTagModal.propTypes = {
  tag: TagPropType.isRequired,
  onClose: PropTypes.func.isRequired,
};
